import { THRESHOLD_INTERVAL_MIN_LENGTH_PX } from '../constants.js';
import { useGaugeChartAspectRatio } from '../hooks/useGaugeChartAspectRatio.js';
import { useGaugeChartBaseColorContext } from '../hooks/useGaugeChartBaseColorContext.js';
import { useGaugeChartRangeMaxContext } from '../hooks/useGaugeChartRangeMaxContext.js';
import { useGaugeChartRangeMinContext } from '../hooks/useGaugeChartRangeMinContext.js';
import { useGaugeChartShowThresholdIndicatorsContext } from '../hooks/useGaugeChartShowThresholdIndicatorsContext.js';
import { useGaugeChartThresholdContext } from '../hooks/useGaugeChartThresholdContext.js';
import { buildArc } from '../utils/build-arc.js';
import { buildThresholdIntervalArcs } from '../utils/build-threshold-interval-arcs.js';
import { computeThresholdBandGeometry } from '../utils/compute-threshold-band-geometry.js';

/**
 * @internal
 */
export const GaugeThresholdIntervalArcs = () => {
  const thresholds = useGaugeChartThresholdContext();
  const showThresholdIndicators = useGaugeChartShowThresholdIndicatorsContext();
  const min = useGaugeChartRangeMinContext();
  const max = useGaugeChartRangeMaxContext();
  const baseColor = useGaugeChartBaseColorContext();
  const { arcOuterRadius, arcInnerRadius } = useGaugeChartAspectRatio();

  if (!showThresholdIndicators || thresholds.length === 0) {
    return null;
  }

  const { innerRadius, outerRadius, midRadius, gap } =
    computeThresholdBandGeometry(arcInnerRadius, arcOuterRadius);

  const segments = buildThresholdIntervalArcs(
    thresholds,
    min,
    max,
    midRadius,
    baseColor,
    gap,
    THRESHOLD_INTERVAL_MIN_LENGTH_PX,
  );

  return segments.map((segment, i) => (
    <path
      key={i}
      d={buildArc(
        innerRadius,
        outerRadius,
        segment.startAngle,
        segment.endAngle,
      )}
      fill={segment.color}
      data-testid="gauge-threshold-interval-arc"
    />
  ));
};
